import { render, staticRenderFns } from "./IncomeSurcharges.vue?vue&type=template&id=48187fa0&lang=pug"
import script from "./IncomeSurcharges.vue?vue&type=script&lang=js"
export * from "./IncomeSurcharges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {IncomeCalculator: require('/home/docker/code/frontend/components/IncomeCalculator.vue').default})
